import { fetchApi } from '@/config/axiosSetting';
import {
  GetRecievedCorrectiveParamsType,
  GetRecievedCorrectiveResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getRecievedCorrectiveImages/getRecievedCorrectiveImages.type';

export const getRecievedCorrectiveImagesFunction = (
  params: GetRecievedCorrectiveParamsType,
): Promise<GetRecievedCorrectiveResponseType> => {
  return fetchApi.get(
    `/property/reports/${params.id}/accident_users/damaged/images/corrective/receive/list/`,
    {
      params: {
        damaged_id: params.damaged_id,
      },
    },
  );
};
